import details from './details/text.js';
import list from './list/text.js';

export default {
  header: {
    notes: 'Activities page title',
    message: 'Activities',
  },
  action: {
    newActivity: {
      notes: 'Start new activity action',
      message: 'New activity',
    },
    complete: {
      notes: 'Complete activity action',
      message: 'Complete',
      confirm: {
        notes: 'Confirm complete activity action',
        message: 'Yes, complete',
      },
    },
  },
  newDialog: {
    header: {
      notes: 'Header in new activities dialog',
      message: 'New activity',
    },
    noProtocols: {
      notes: 'No applicable protocols exists',
      message:
        'No protocols exists for this equipment. Unable to create new activities.',
    },
  },
  completeDialog: {
    header: {
      notes: 'Header in activity complete dialog',
      message: 'Complete activity',
    },
    text: {
      notes: 'Text in content area of complete activity dialog',
      message:
        'Are you sure you want to complete the activity?\n\nYou will not be able to re-open it.',
    },
  },
  generalInfo: {
    activityHeader: {
      notes:
        'Header of activity section when viewing details in general information tab',
      message: 'Activity',
    },
  },
  model: {
    name: {
      notes: 'Activity name',
      message: 'Name',
    },
    operatingHours: {
      notes: 'Operating hours',
      message: 'Work hours',
    },
    protocolName: {
      notes: 'Name of protocol for activity',
      message: 'Type',
    },
    equipment: {
      notes: 'Equipment activity is performed on',
      message: 'Equipment',
    },
    inspector: {
      notes: 'Inspector property display name',
      message: 'Assigned to',
    },
    inspectedAt: {
      notes: 'Inspected at property display name',
      message: 'Performed',
    },
    published: {
      notes: 'Published at property display name',
      message: 'Published',
    },
    status: {
      notes: 'Status property display name for activity',
      message: 'Status',
      unassigned: {
        notes: 'Status "unassigned" display name for activity',
        message: 'Unassigned',
      },
      assigned: {
        notes: 'Status "assigned" display name for activity',
        message: 'In progress',
      },
      finished: {
        notes: 'Status "finished" display name for activity',
        message: 'Completed',
      },
    },
    reportDocument: {
      notes:
        'Display name for column indicating if there are any attached report documents',
      message: 'Report',
    },
  },
  task: {
    model: {
      orderBy: {
        notes: 'Order by property display name',
        message: 'Pos.',
      },
      name: {
        notes: 'Name property display name',
        message: 'Task',
      },
      notesField: {
        notes: 'Notes property display name',
        message: 'Notes',
      },
      attachment: {
        notes: 'Attachment property display name',
        message: 'Attachments',
      },
    },
    images: {
      unsupportedFileType: {
        notes: 'Unsupported file type for uploaded task image',
        message: 'Unsupported file type',
      },
      uploadSuccess: {
        notes: 'Successfully uploaded an image to a task',
        message: 'Successfully uploaded "{{caption}}"',
      },
      deleteSuccess: {
        notes: 'Successfully deleted an image from a task',
        message: 'Image "{{caption}}" was deleted',
      },
    },
  },
  complete: {
    notes: 'Activity progress in text, e.g. 5 / 7 complete',
    message: '{{complete}} / {{total}} complete',
  },
  notification: {
    completedSuccess: {
      notes:
        'Notification message when activity successfully has been completed',
      message: 'Activity completed!',
    },
  },
  list,
  details,
};
